import { resolveRoute } from 'vike/routing'
import type { RouteSync } from 'vike/types'

const isValidLang = (lang: string) => /^[a-z]{2}$/.test(lang)

export const route: RouteSync = (pageContext) => {
  const routes = [
    '/micro-apps/document-formatter',
    '/@lang/micro-apps/document-formatter',
    '/micro-apps/document-formatter/@documentType',
    '/@lang/micro-apps/document-formatter/@documentType',
  ]

  for (const route of routes) {
    const result = resolveRoute(route, pageContext.urlPathname)
    if (result.match) {
      // Validate that @lang is a 2-letter language code if present
      const lang = result.routeParams?.lang
      if (lang && !isValidLang(lang)) {
        continue
      }
      return result
    }
  }

  return false
}
